import * as React from 'react';

import { ApolloError } from 'apollo-client';
import { Mutation } from 'react-apollo';

import ToastActions from 'actions/ToastActions';

import { RemoveDeviceFromUserVariables } from 'settings/queries/__generated__/RemoveDeviceFromUser';

import DEVICES_QUERY from 'settings/queries/devicesQuery.gql';
import REMOVE_DEVICE_FROM_USER_MUTATION from 'settings/queries/RemoveDeviceFromUserMutation.gql';

type Props = {
  children: (
    removeDevice: (input: { variables: RemoveDeviceFromUserVariables }) => void
  ) => React.ReactElement;
  deviceName: string;
};

export default function RemoveDeviceFromUserMutationContainer(props: Props) {
  return (
    <Mutation
      mutation={REMOVE_DEVICE_FROM_USER_MUTATION}
      // @ts-ignore ts upgrade with new apollo-link update borked things.  Type mismatch between graphql libraries.
      refetchQueries={() => [{ query: DEVICES_QUERY }]}
      onCompleted={() =>
        ToastActions.showSuccessToast(`${props.deviceName} was successfully removed`)
      }
      onError={(error: ApolloError) => ToastActions.showErrorToast(error.message)}>
      {props.children}
    </Mutation>
  );
}
